import { SelectListItem } from "./select-list-item";

export class SendFormToCustomerModel {
    CustomerID:number;
    SendByEmail:boolean;
    SendBySMS:boolean;
    SelectedBranch?:number;
    Businesses:SelectListItem[];
    SelectedForms:number[];
    FormID:number;
    FormDataID:number;
    CanSendSms: boolean;
    CanSendEmail: boolean;
    SelectedTherapist?:number;

    constructor(obj?: any){
        this.CustomerID = obj && obj.CustomerID || 0;
        this.SendByEmail = obj && obj.SendByEmail || false;
        this.SendBySMS = obj && obj.SendBySMS || false;
        this.SelectedBranch = obj && obj.SelectedBranch || null;
        this.Businesses = obj && obj.Businesses || [];
        this.SelectedForms = obj && obj.SelectedForms || [];
        this.FormID = obj && obj.FormID || 0;
        this.FormDataID = obj && obj.FormDataID || 0;
        this.CanSendSms = obj && obj.CanSendSms || false;
        this.CanSendEmail = obj && obj.CanSendEmail || false;
        this.SelectedTherapist = obj && obj.SelectedTherapist || null;
    }
}